// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductNoteCard from "../../modules/Catalog/CatalogProductNoteCard.res.js";
import * as CatalogProductPageActions from "../../modules/Catalog/CatalogProductPageActions.res.js";
import * as CatalogProductInformationCard from "../../modules/Catalog/CatalogProductInformationCard.res.js";
import * as CatalogProductStatusTableCard from "../../modules/Catalog/CatalogProductStatusTableCard.res.js";
import * as CatalogProductVariantTableCard from "../../modules/Catalog/CatalogProductVariantTableCard.res.js";
import * as CatalogProductOrganisationTableCard from "../../modules/Catalog/CatalogProductOrganisationTableCard.res.js";

function CatalogProductPage$AuthSelectShop(props) {
  let productShopIds = props.productShopIds;
  let shops = Auth.useShops();
  let disabledIds = Stdlib_Array.filterMap(shops, param => {
    let id = param.id;
    let match = productShopIds.find(current => current === id);
    if (match !== undefined) {
      return;
    } else {
      return id;
    }
  });
  return JsxRuntime.jsx(Auth.SelectShopFilter.make, {
    disabledIds: disabledIds
  });
}

let AuthSelectShop = {
  make: CatalogProductPage$AuthSelectShop
};

function CatalogProductPage(props) {
  let shopsProductVariants = props.shopsProductVariants;
  let shopsProduct = props.shopsProduct;
  let productShopIds = props.productShopIds;
  let cku = props.cku;
  let activeShop = Auth.useActiveShop();
  let notifier = Notifier.use(undefined, undefined);
  let scope = Auth.useScope();
  let someProduct = shopsProduct.length !== 0;
  let renderActions = () => {
    let match = shopsProduct[0];
    let match$1 = shopsProductVariants[0];
    if (scope.TAG === "Organisation" || match === undefined || match$1 === undefined) {
      return null;
    } else {
      return JsxRuntime.jsx(CatalogProductPageActions.make, {
        cku: cku,
        id: match.id,
        status: match.status,
        variants: match$1
      });
    }
  };
  let renderHeaderActions;
  if (scope.TAG === "Organisation") {
    let shops = scope.shops;
    renderHeaderActions = () => {
      let match = shopsProduct[0];
      let match$1 = shopsProductVariants[0];
      return JsxRuntime.jsxs(Inline.make, {
        children: [
          JsxRuntime.jsxs(Inline.make, {
            children: [
              shops.length < 6 ? JsxRuntime.jsx(CatalogProductPage$AuthSelectShop, {
                  productShopIds: productShopIds
                }) : null,
              someProduct ? null : JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("No product association to this shop has been recorded."),
                  variation: "negative"
                })
            ],
            space: "normal"
          }),
          match !== undefined && match$1 !== undefined ? JsxRuntime.jsx(CatalogProductPageActions.make, {
              cku: cku,
              id: match.id,
              status: match.status,
              variants: match$1
            }) : null
        ],
        align: "spaceBetween",
        grow: true
      });
    };
  } else {
    renderHeaderActions = undefined;
  }
  let pageTitle = Stdlib_Option.mapOr(shopsProduct[0], "", param => param.name);
  let renderTitleEnd = () => {
    let match = shopsProduct[0];
    let product;
    if (match === undefined) {
      return null;
    }
    if (scope.TAG === "Organisation") {
      if (scope.activeShop === undefined) {
        return null;
      }
      product = match;
    } else {
      product = match;
    }
    let status = product.status;
    return JsxRuntime.jsx("div", {
      children: status !== undefined ? JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
          value: status
        }) : null,
      style: {
        alignSelf: "center"
      }
    });
  };
  let tmp;
  if (someProduct) {
    let tmp$1;
    tmp$1 = scope.TAG === "Organisation" && scope.activeShop === undefined ? JsxRuntime.jsx(CatalogProductStatusTableCard.make, {
        shopsProduct: shopsProduct
      }) : null;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Notifier.Banner.make, {
          notifier: notifier
        }),
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Stack.make, {
            children: JsxRuntime.jsxs(Group.make, {
              children: [
                JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(CatalogProductInformationCard.make, {
                      product: shopsProduct[0]
                    }),
                    JsxRuntime.jsx(CatalogProductOrganisationTableCard.make, {
                      shopsProduct: shopsProduct
                    }),
                    tmp$1,
                    JsxRuntime.jsx(CatalogProductNoteCard.make, {
                      productId: Stdlib_Option.map(shopsProduct.find(product => product.shopId === Stdlib_Option.map(activeShop, param => param.id)), product => product.id),
                      internalNote: Stdlib_Option.mapOr(shopsProduct.find(product => product.shopId === Stdlib_Option.map(activeShop, param => param.id)), "", product => product.internalNote)
                    })
                  ],
                  space: "large"
                }),
                JsxRuntime.jsx(CatalogProductVariantTableCard.make, {
                  shopsProductVariants: shopsProductVariants
                })
              ],
              grid: [
                "30%",
                "70%"
              ],
              wrap: false,
              grow: false,
              spaceX: "large"
            }),
            space: "medium"
          }),
          spaceTop: "medium"
        })
      ]
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(Page.make, {
    children: tmp,
    title: pageTitle,
    renderTitleEnd: renderTitleEnd,
    renderActions: renderActions,
    renderHeaderActions: renderHeaderActions
  });
}

let make = React.memo(CatalogProductPage);

let Config;

export {
  Config,
  AuthSelectShop,
  make,
}
/* make Not a pure module */
